//React
import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as favoriteAction from '../action/favoriteAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';

import DialogActions from '@material-ui/core/DialogActions';

//Add
//Icon
import CloseIcon from '@material-ui/icons/Close';


class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
  	}
  }


	render() {
		return (
			<Dialog
        open={this.props.open}
        maxWidth='xs'
        onClose={ () => this.props.close() }
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            お気に入り
          </div>
          <IconButton
            onClick={ () => this.props.close() }
          >
            <CloseIcon/>
          </IconButton>
        </div>

        {
          (this.props.type === 'del') && (
            <div>
              <div style={{margin:'10px'}}>
                <div>お気に入りを解除しますか？</div>
              </div>
              <DialogActions>
                <Button
                  variant="contained"
                  color='primary'
                  size="large"
                  onClick={ () => this.props.apply('del') }
                >
                  解除する
                </Button>
              </DialogActions>
            </div>
          )
        }
        {
          (this.props.type === 'add') && (
            <div>
              <div style={{margin:'10px'}}>
                <div>お気に入りに登録したことをお相手に通知しますか？</div>
                <div style={{fontSize:'0.9em',color:'#666'}}>※通知に関わらず、あなたのシークレット写真は公開されます</div>

              </div>
              <DialogActions>
                <Button
                  variant="contained"
                  color='primary'
                  size="large"
                  onClick={ () => this.props.apply('addNotice') }
                >
                  通知する
                </Button>
                <Button
                  variant="outlined"
                  color='primary'
                  size="large"
                  onClick={ () => this.props.apply('add') }
                >
                  通知しない
                </Button>
              </DialogActions>
            </div>
          )
        }

			</Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...favoriteAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
